import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import type { ValidationFormValues } from "../../types/form.types";
import * as Yup from "yup";

const initialValues = {
  documentType: "",
  documentNumber: "",
};

export const useValidationForm = (
  onValidate: (values: ValidationFormValues) => void
) => {
  const { t } = useTranslation();
  const validationSchema = Yup.object({
    documentType: Yup.string().required(t("field.required")),
    documentNumber: Yup.string()
      .matches(/^[a-zA-Z0-9]+$/, { message: t("field.documentNumber.invalid") })
      .required(t("field.required"))
      .max(25, t("field.documentNumber.max", { maxChars: 25 })),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: onValidate,
  });

  return {
    formik,
    validationSchema,
  };
};
